__turbopack_context__.v({
  "icon": "RsVJOG_icon",
});
